import React from 'react';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { ProductionOrderBulkRequirement } from '../services/productionOrderService';

export const PACKAGING_NOT_SET = 'Not set';

export function format_packaging_name(value?: string | null): string {
  const trimmed = value?.trim();
  return trimmed ? trimmed : PACKAGING_NOT_SET;
}

export function format_combined_container(
  container_name?: string | null,
  size?: string | null
): string {
  const name = container_name?.trim();
  const size_label = size?.trim();
  if (name && size_label) {
    return `${name} (${size_label})`;
  }
  if (name) {
    return name;
  }
  if (size_label) {
    return size_label;
  }
  return PACKAGING_NOT_SET;
}

export function format_units_per_case(value?: number | null): string {
  if (value == null || Number.isNaN(value)) {
    return PACKAGING_NOT_SET;
  }
  return String(value);
}

export function show_cases_used_column(
  requirements: Array<{ cases_used?: number | null }>
): boolean {
  return requirements.some((req) => req.cases_used != null);
}

interface RequiredBulkProductsTableProps {
  requirements: ProductionOrderBulkRequirement[];
  box_size?: string | null;
  container_name?: string | null;
  size?: string | null;
  units_per_case?: number | null;
  table_container_sx?: object;
}

const RequiredBulkProductsTable: React.FC<RequiredBulkProductsTableProps> = ({
  requirements,
  box_size,
  container_name,
  size,
  units_per_case,
  table_container_sx,
}) => {
  const show_cases_used = show_cases_used_column(requirements);
  const box_label = format_packaging_name(box_size);
  const container_label = format_combined_container(container_name, size);
  const units_per_case_label = format_units_per_case(units_per_case);

  return (
    <TableContainer component={Paper} sx={table_container_sx}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Bulk Product</TableCell>
            <TableCell>SKU</TableCell>
            <TableCell align="right">Cases Needed</TableCell>
            <TableCell>Box</TableCell>
            <TableCell>Units per Case</TableCell>
            <TableCell>Container</TableCell>
            {show_cases_used && <TableCell align="right">Cases Used</TableCell>}
          </TableRow>
        </TableHead>
        <TableBody>
          {requirements.map((req) => (
            <TableRow key={req.bulk_product_id}>
              <TableCell>{req.bulk_product.name}</TableCell>
              <TableCell>{req.bulk_product.sku_number}</TableCell>
              <TableCell align="right">{req.cases_needed}</TableCell>
              <TableCell>{box_label}</TableCell>
              <TableCell>{units_per_case_label}</TableCell>
              <TableCell>{container_label}</TableCell>
              {show_cases_used && (
                <TableCell align="right">{req.cases_used != null ? req.cases_used : ''}</TableCell>
              )}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default RequiredBulkProductsTable;
